var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5364 4.77086C17.6333 2.78782 14.9575 1.55224 12 1.55224C6.23554 1.55224 1.55229 6.23549 1.55229 12C1.55229 17.7645 6.23554 22.4478 12 22.4478C17.7645 22.4478 22.4478 17.7645 22.4478 12C22.4478 9.75014 21.7334 7.66498 20.5199 5.95869L11.205 15L6 9.9806L7.09407 8.8998L11.205 12.8583L19.5364 4.77086ZM20.6534 3.68659C18.4698 1.4143 15.3999 0 12 0C5.37318 0 0 5.37314 0 12C0 18.6269 5.37318 24 12 24C18.6269 24 24 18.6269 24 12C24 9.32718 23.1259 6.8583 21.648 4.86367L24 2.5808L22.9059 1.5L20.6534 3.68659Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Check1.642451cadfa06d378f2155cd8f15c6e1.svg";